module.exports = __webpack_public_path__ + "img/footerVisa.99fa17f9.jpeg";